export const filters = [
  {
    rowId: 0,
    rowName: "Filter",
    fields: [
      {
        name: "createdAtFrom",
        type: "datetime",
        placeholder: "Date From",
      },
      {
        name: "createdAtTo",
        type: "datetime",
        placeholder: "Date To",
      },
    ],
  },
]
